import dayjs from "dayjs";

export const QUICK_DURATION_DAYS = [1, 3, 7, 30];

export const getRecommendedDurationSeconds = campaignType => {
    const durationSeconds = Number(campaignType?.recommendedDuration);

    return Number.isFinite(durationSeconds) && durationSeconds > 0 ? durationSeconds : null;
};

export const calculateTill = (from, days) => dayjs(from).add(days, "day");

export const calculateTillFromDuration = (from, durationSeconds) =>
    dayjs(from).add(durationSeconds, "second");

export const isTillForDuration = (from, till, durationSeconds) =>
    durationSeconds !== null && dayjs(till).isSame(calculateTillFromDuration(from, durationSeconds));

const formatPart = (value, unit) => `${value} ${unit}${value === 1 ? "" : "s"}`;

const formatMinutes = totalMinutes => {
    if (totalMinutes < 0) {
        return "Invalid date range";
    }

    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;
    const parts = [];

    if (days > 0) parts.push(formatPart(days, "day"));
    if (hours > 0) parts.push(formatPart(hours, "hour"));
    if (minutes > 0 || parts.length === 0) parts.push(formatPart(minutes, "minute"));

    return parts.join(" ");
};

export const formatDurationSeconds = durationSeconds => {
    const seconds = Number(durationSeconds);

    if (!Number.isFinite(seconds) || seconds < 0) {
        return "";
    }

    const totalMinutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedMinutes = formatMinutes(totalMinutes);

    return remainingSeconds === 0
        ? formattedMinutes
        : `${formattedMinutes === "0 minutes" ? "" : `${formattedMinutes} `}${formatPart(remainingSeconds, "second")}`;
};

export const formatDurationInput = durationSeconds =>
    durationSeconds == null ? "" : formatDurationSeconds(durationSeconds);

export const formatDurationDaysHours = durationSeconds => {
    const seconds = Number(durationSeconds);
    if (!Number.isFinite(seconds) || seconds < 0) {
        return "";
    }

    const totalHours = Math.floor(seconds / 3600);
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    const parts = [];

    if (days > 0) parts.push(formatPart(days, "day"));
    if (hours > 0 || parts.length === 0) parts.push(formatPart(hours, "hour"));

    return parts.join(" ");
};

export const durationHoursToSeconds = durationHours => {
    if (durationHours == null || durationHours === "") {
        return null;
    }

    const hours = Number(durationHours);
    return Number.isFinite(hours) && hours >= 0 ? hours * 3600 : null;
};

export const durationSecondsToHours = durationSeconds =>
    durationSeconds == null ? null : Number(durationSeconds) / 3600;

export const durationSecondsToParts = durationSeconds => {
    const totalSeconds = Number(durationSeconds);
    if (!Number.isFinite(totalSeconds) || totalSeconds < 0) {
        return {days: 0, hours: 0, minutes: 0, seconds: 0};
    }

    return {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60
    };
};

export const durationPartsToSeconds = ({days, hours, minutes, seconds}) =>
    (Number(days) || 0) * 86400
    + (Number(hours) || 0) * 3600
    + (Number(minutes) || 0) * 60
    + (Number(seconds) || 0);

export const formatDuration = (from, till) =>
    formatMinutes(dayjs(till).diff(dayjs(from), "minute"));

export const formatDurationHours = hours => {
    const numericHours = Number(hours);

    return Number.isFinite(numericHours) && numericHours >= 0
        ? formatMinutes(numericHours * 60)
        : "";
};
